import styled from 'styled-components'

export const RelatedCustomerStoriesContainer = styled.div`
  background: ${p => p.theme.webMktPalette.grayNeutral[10]};
  position: relative;
  padding: 64px 0 96px;

  &:before {
    content: '';
    position: absolute;
    border: 2px solid ${p => p.theme.webMktPalette.orange[50]};
    width: 160px;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  }

  h2 {
    text-align: center;
    margin-bottom: 64px;
    padding: 0 16px;
    ${p => p.theme.breakpoints.down('xs')} {
      margin: 0 auto 48px;
    }
  }

  .RelatedCustomerStories {
    display: grid;
    grid-template-columns: repeat(auto-fit, 384px);
    justify-content: center;
    grid-column-gap: 24px;

    ${p => p.theme.breakpoints.down('md')} {
      grid-template-columns: repeat(auto-fit, 304px);
    }
    ${p => p.theme.breakpoints.down('sm')} {
      grid-column-gap: 16px;
      grid-row-gap: 48px;
      grid-template-columns: repeat(auto-fit, 360px);
    }
    ${p => p.theme.breakpoints.down('xs')} {
      max-width: 328px;
      margin: 0 auto;
      grid-row-gap: 16px;
      grid-template-columns: repeat(auto-fit, minmax(0, 328px));
    }
  }

  .RelatedCustomerStories__Item {
    transition: box-shadow 0.2s ease-in-out;
    box-shadow: none;
    background: ${p => p.theme.webMktPalette.text.primaryWhite};
    &:hover {
      box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.1);
    }
  }

  .RelatedCustomerStories__Image-Container {
    height: 216px;
    position: relative;
    ${p => p.theme.breakpoints.down('md')} {
      height: 171px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      height: 203px;
    }
    &:before {
      content: '';
      background: rgba(0, 0, 0, 0.2);
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .RelatedCustomerStories__WhiteLogo {
    position: absolute;
    width: 240px;
    height: 120px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .RelatedCustomerStories__default_logo {
    right: 1px;
    bottom: 1px;
    height: 48px;
    width: 48px;
    transform: none;
    top: auto;
    left: auto;
  }

  .RelatedCustomerStories__BackgroundImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .RelatedCustomerStories__Text-Container {
    padding: 24px 24px 32px 24px;

    > h6:hover {
      color: #0067df;
    }

    p {
      margin: 0;
    }

    > h6,
    .CTA,
    .RelatedCustomerStories__Body {
      margin-top: 16px;
    }

    .RelatedCustomerStories__Body {
      color: ${p => p.theme.webMktPalette.text.secondary};
    }
  }
`
